module.exports = __webpack_public_path__ + "static/media/reloj.24d89fcb.svg";